import { Component, inject } from '@angular/core'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco'
import { LanguageSelectorComponent } from '@main/common/language-selector/language-selector.component'
import { FacebookLinkIconComponent } from '../facebook-link-icon/facebook-link-icon.component'
import { InstagramLinkIconComponent } from '../instagram-link-icon/instagram-link-icon.component'
import { TwitterLinkIconComponent } from '../twitter-link-icon/twitter-link-icon.component'
import { YoutubeLinkIconComponent } from '../youtube-link-icon/youtube-link-icon.component'
import { AppStateService } from '@core/states/app-state.service';
import { PublicPages } from '@main/PublicPages';
import { CardBrandingLightComponent } from '@main/common/card-branding-light/card-branding-light.component';


@Component({
    selector: 'app-footer-1',
    standalone: true,
    templateUrl: './footer-1.component.html',
    styleUrl: './footer-1.component.scss',
    imports: [
        FacebookLinkIconComponent,
        InstagramLinkIconComponent,
        YoutubeLinkIconComponent,
        TwitterLinkIconComponent,
        TranslocoDirective,
        LanguageSelectorComponent,
        RouterLink,
        RouterLinkActive,
        CardBrandingLightComponent,
    ],
})
export class Footer1Component {
    transLocoService = inject(TranslocoService)
    appService = inject(AppStateService)
    lang: 'en' | 'sr' = this.transLocoService.getActiveLang() === 'en_US' ? 'en' : 'sr'

    pages = PublicPages
    currentYear = new Date().getFullYear()
}
